import React from "react";
import { render, screen } from "@testing-library/react";
import "@testing-library/jest-dom";

import { FullPageChatLayout } from "./FullPageChatLayout";

jest.mock("@metalmind-ab/mmagent-chat-ui", () => ({
  ChatMessage: ({ message }: { message: any }) => (
    <div data-testid={`chat-message-${message.id}`}>{message.content}</div>
  ),
  JobProgressIndicator: () => null,
  useChatStore: (selector: (state: any) => any) =>
    selector({
      backgroundJobs: [],
      removeBackgroundJob: jest.fn(),
      messages: [],
    }),
}));

beforeAll(() => {
  Object.defineProperty(HTMLElement.prototype, "scrollIntoView", {
    configurable: true,
    value: jest.fn(),
  });
  Object.defineProperty(URL, "createObjectURL", {
    configurable: true,
    value: jest.fn(() => "blob:test-url"),
  });
  Object.defineProperty(URL, "revokeObjectURL", {
    configurable: true,
    value: jest.fn(),
  });
});

const visibleMessage = (id: string, content: string) =>
  ({
    id,
    role: "user",
    content,
    createdAt: new Date().toISOString(),
  }) as any;

const renderLayout = (
  overrides: Partial<React.ComponentProps<typeof FullPageChatLayout>> = {},
) =>
  render(
    <FullPageChatLayout
      messages={[]}
      onSendMessage={jest.fn()}
      isLoading={false}
      conversations={[]}
      onLoadConversation={jest.fn()}
      onNewConversation={jest.fn()}
      onSearchConversations={jest.fn()}
      onLoadMoreConversations={jest.fn()}
      conversationsLoading={false}
      currentConversationId={1}
      hasOlderMessages
      onLoadOlderMessages={jest.fn()}
      {...overrides}
    />,
  );

describe("FullPageChatLayout hidden-page auto-backfill (FE #1482)", () => {
  it("shows only the Load earlier messages button when the newest page maps to nothing (pre-backfill shape)", () => {
    renderLayout({ messages: [] });

    expect(
      screen.getByRole("button", { name: /load earlier messages/i }),
    ).toBeInTheDocument();
    expect(screen.queryByTestId(/^chat-message-/)).not.toBeInTheDocument();
  });

  it("renders the older page's visible messages without any click once the container backfills them", () => {
    const onLoadOlderMessages = jest.fn();
    renderLayout({
      // Mirrors the state Chat.tsx's loadConversation reaches after
      // backfillConversationMessageWindowUntilVisible walks back past a
      // hidden-only newest page and finds visible rows on an older one:
      // messages is populated automatically, and hasOlderMessages stays
      // true because pages older than the backfill horizon may still exist.
      messages: [
        visibleMessage("msg-15", "user-15"),
        visibleMessage("msg-16", "assistant-16"),
      ],
      hasOlderMessages: true,
      onLoadOlderMessages,
    });

    expect(screen.getByTestId("chat-message-msg-15")).toHaveTextContent(
      "user-15",
    );
    expect(screen.getByTestId("chat-message-msg-16")).toHaveTextContent(
      "assistant-16",
    );
    // The messages are already visible; the container reached this state
    // without the user clicking "Load earlier messages".
    expect(onLoadOlderMessages).not.toHaveBeenCalled();
    // The button itself may still be present (more pages could exist beyond
    // the backfill bound) -- its presence alone is not the empty-chat bug.
    expect(
      screen.getByRole("button", { name: /load earlier messages/i }),
    ).toBeInTheDocument();
  });
});
